<div class="container">
  <div class="row">
    <div class="col">
      <h1>{{ 'ApplyForFamilyMemberInsurance' | translate }}</h1>
    </div>
  </div>

  <form [formGroup]="familyMemberInsuranceFormGroup">
    <alert message="ApplyForFamilyMemberInsuranceInfo" alertType="info"></alert>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'InsuranceApplicationDate' | translate }}</mat-label>
          <input
            matInput
            placeholder="{{ 'InsuranceApplicationDatePlaceholder' | translate }}"
            [matDatepicker]="pickInsuranceApplicationDate"
            formControlName="insuranceApplicationDate"
            [matDatepickerFilter]="validateDateTest"
            required
            />
            <mat-datepicker-toggle matSuffix [for]="pickInsuranceApplicationDate"></mat-datepicker-toggle>
            <mat-datepicker #pickInsuranceApplicationDate></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      @if (isInsured) {
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'InsuranceDeregistrationDate' | translate }}</mat-label>
              <input
                matInput
                placeholder="{{ 'InsuranceDeregistrationDatePlaceholder' | translate }}"
                [matDatepicker]="pickinsuranceDeregistrationDate"
                formControlName="insuranceDeregistrationDate"
                [matDatepickerFilter]="validateDeregistrationDateTest"
                />
                <mat-datepicker-toggle matSuffix [for]="pickinsuranceDeregistrationDate"></mat-datepicker-toggle>
                <mat-datepicker #pickinsuranceDeregistrationDate></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        }

        @if (!!insuranceApplicationDate) {
          <div class="row">
            <div class="col">
              <h3 class="statement-header">{{ 'Statement' | translate }}</h3>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <mat-checkbox formControlName="isStatementAccepted">
                {{ 'ApplyForFamilyMemberInsuranceStatement' | translate }}
              </mat-checkbox>
            </div>
          </div>
          @if (!isStatementAccepted) {
            <alert message="ApplyForFamilyMemberInsuranceStatementErrorMessage" alertType="error"></alert>
          }
          <alert message="ApplyForFamilyMemberInsuranceInfoForChildren" alertType="info"></alert>
          @if (!isUnderage && isChild && !files?.length && !data.alreadySavedFiles?.length) {
            <alert
              message="YouHaveToAttachAtLeastOneFileForUnderage"
              alertType="error"
            ></alert>
          }
          <alert message="RememberToCoverYourFaceInThePhoto" alertType="info"></alert>
          @for (file of data.alreadySavedFiles; track file) {
            <div>
              <mat-icon>description</mat-icon>
              {{ file }}
              <br />
            </div>
          }
          @if (canEditForm) {
            <fileUpload
              [maxFileCount]="maxFileCount | async"
              [alreadySavedFiles]="data.alreadySavedFiles"
              (onFilesChange)="onOptionChange($event)"
            ></fileUpload>
          }
        }

        <div class="row">
          <div class="col">
            <button mat-raised-button (click)="cancel()">{{ 'Cancel' | translate }}</button>
          </div>
          <div class="col">
            <button [disabled]="!canEditForm" class="save-button" mat-raised-button color="primary" (click)="submit()">{{ 'Save' | translate }}</button>
          </div>
        </div>
      </form>
    </div>
